import React from "react";
import styles from "../statics/styles/file-upload-viewer-scss.js";
const PptIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "40", height: "42", viewBox: "0 0 40 42", ...props }, /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("g", { className: styles.file_upload_icon_frame, strokeLinejoin: "bevel" }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M35.5 41.5h-32V.5h19.45L35.5 13.31z" }), /* @__PURE__ */ React.createElement("path", { d: "m22.59 13.36 12.91-.05-.64-.63L23.59 1.14 22.95.5z" })), /* @__PURE__ */ React.createElement(
  "path",
  {
    className: styles.file_upload_icon_background,
    d: "M21.4 23.2c0-.6-.2-1-.5-1.2-.3-.2-.7-.4-1.3-.4h-2.1v3.2h2.1c.5 0 1-.1 1.3-.4.4-.3.5-.7.5-1.2zm2.3-.1c0 1.3-.3 2.2-1 2.8-.7.5-1.6.8-2.8.8h-2.3v4h-2.3v-11h4.8c1.1 0 2 .3 2.6.9.7.5 1 1.4 1 2.5z"
  }
)));
export {
  PptIcon
};
//# sourceMappingURL=ppt-icon.js.map
